import { useFormContext } from 'react-hook-form'

import { Input } from '@/components/Forms'
import { OfficialReportType } from '@/types/officialReport'
import styles from '../OfficialReportModal.module.scss'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../../constant'

interface Props {
    reportType: OfficialReportType
}

export const ReportTime = ({ reportType }: Props) => {
    const { register } = useFormContext()
    return (
        <div className={styles.fieldsRow}>
            <Input fullWidth label="Date of incident" {...register(OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue)} />
            {reportType === OfficialReportType.Generic && (
                <Input fullWidth label="Time of incident" {...register(OFFICIAL_REPORT_FORM_FIELDS.timeOfIssue)} />
            )}
        </div>
    )
}
